import "@shoelace-style/shoelace/dist/components/dialog/dialog.js";
import React, { useEffect, useState } from "react";
import {
  getShortcutList,
  useKeyboardShortcuts,
} from "../../utils/keyboardShortcuts";

/**
 * KeyboardShortcutsHelp - Modal component to display keyboard shortcuts
 */
const KeyboardShortcutsHelp = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dialogRef = React.useRef(null);
  const shortcutsList = getShortcutList();

  // Register ? shortcut to toggle the dialog
  useKeyboardShortcuts({
    "?": () => toggleDialog(),
  });

  // Close dialog with Escape key
  useEffect(() => {
    if (isOpen && dialogRef.current) {
      // Show the dialog when isOpen becomes true
      dialogRef.current.show();
    }
  }, [isOpen]);

  // Handle dialog close event
  const handleClose = () => {
    setIsOpen(false);
  };

  const toggleDialog = () => {
    if (isOpen) {
      dialogRef.current?.hide();
    } else {
      setIsOpen(true);
    }
  };

  return (
    <sl-dialog
      ref={dialogRef}
      label="Keyboard Shortcuts"
      className="keyboard-shortcuts-dialog"
      onSlAfterHide={handleClose}
    >
      <div className="max-h-[70vh] overflow-y-auto pr-2">
        {shortcutsList.map((category) => (
          <div key={category.category} className="mb-6">
            <h3 className="text-lg font-medium text-[#4db1e0] border-b border-gray-700 pb-2 mb-3">
              {category.category}
            </h3>
            <div className="grid grid-cols-2 gap-y-3 gap-x-4">
              {category.shortcuts.map((shortcut, index) => (
                <div key={index} className="flex justify-between text-sm">
                  <span className="text-gray-400">{shortcut.description}</span>
                  <kbd className="px-2 py-1 ml-3 bg-[#262b30] text-gray-200 rounded text-xs font-mono">
                    {shortcut.key}
                  </kbd>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div slot="footer" className="flex justify-between items-center">
        <div className="text-xs text-gray-400">
          Press <kbd className="px-1 bg-[#262b30] rounded">?</kbd> anytime to
          show this dialog
        </div>
        <sl-button variant="primary" onClick={() => dialogRef.current?.hide()}>
          Close
        </sl-button>
      </div>
    </sl-dialog>
  );
};

export default KeyboardShortcutsHelp;
